export function EFUploadImage() {
  return (
    <svg
      width='36'
      height='36'
      viewBox='0 0 36 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_bd_15338_89458)'>
        <rect
          x='4'
          width='28'
          height='28'
          rx='14'
          fill='#656565'
          fillOpacity='0.6'
          shapeRendering='crispEdges'
        />
        <path
          d='M21 14C21 15.6569 19.6569 17 18 17C16.3431 17 15 15.6569 15 14C15 12.3431 16.3431 11 18 11C19.6569 11 21 12.3431 21 14ZM20 14C20 12.8954 19.1046 12 18 12C16.8954 12 16 12.8954 16 14C16 15.1046 16.8954 16 18 16C19.1046 16 20 15.1046 20 14ZM16.618 8C16.0499 8 15.5305 8.321 15.2764 8.82918L14.691 10H14C12.8954 10 12 10.8954 12 12V17C12 18.1046 12.8954 19 14 19H22C23.1046 19 24 18.1046 24 17V12C24 10.8954 23.1046 10 22 10H21.309L20.7236 8.82918C20.4695 8.321 19.9501 8 19.382 8H16.618ZM16.1708 9.27639C16.2555 9.107 16.4286 9 16.618 9H19.382C19.5714 9 19.7445 9.107 19.8292 9.27639L20.5528 10.7236C20.6375 10.893 20.8106 11 21 11H22C22.5523 11 23 11.4477 23 12V17C23 17.5523 22.5523 18 22 18H14C13.4477 18 13 17.5523 13 17V12C13 11.4477 13.4477 11 14 11H15C15.1894 11 15.3625 10.893 15.4472 10.7236L16.1708 9.27639Z'
          fill='white'
        />
      </g>
      <defs>
        <filter
          id='filter0_bd_15338_89458'
          x='0'
          y='-2'
          width='36'
          height='38'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feGaussianBlur
            in='BackgroundImageFix'
            stdDeviation='1'
          />
          <feComposite
            in2='SourceAlpha'
            operator='in'
            result='effect1_backgroundBlur_15338_89458'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_backgroundBlur_15338_89458'
            result='effect2_dropShadow_15338_89458'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_15338_89458'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  )
}
